module.exports = __webpack_public_path__ + "static/media/visa2-small.5994859d.png";